import { render, staticRenderFns } from "./tab14.vue?vue&type=template&id=13ab36d8&scoped=true&"
import script from "./tab14.vue?vue&type=script&lang=js&"
export * from "./tab14.vue?vue&type=script&lang=js&"
import style0 from "./tab14.vue?vue&type=style&index=0&id=13ab36d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ab36d8",
  null
  
)

export default component.exports